// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "2fbf9dd2" + "." + "b0f014a50f5f2ad6" + ".js";
};